import { ReactionCounterModel, ReactionKind } from "client/Api/Hub/common";
import {
	FontIconName,
	SvgIconValue
} from "client/Components";
import { ensureNotNil } from "client/Misc/utils";
import { useMemo } from "react";
import { getReactionSummary, reactionIconMap } from "./ReactionsCountButton/ReactionsCountButton";

export function useReactionStatistic(
	counters: readonly ReactionCounterModel[]
): ReactionStatistic {
	return useMemo(
		(): ReactionStatistic => getReactionStatistic(counters),
		[counters]
	);
}

export type ReactionStatistic = {
	total: number;
	icon: FontIconName | SvgIconValue;
	kind?: ReactionKind;
};

function getReactionStatistic(
	counters: readonly ReactionCounterModel[]
): ReactionStatistic {
	const { total, reactions } = getReactionSummary(counters);

	let icon: FontIconName | SvgIconValue;
	let kind: ReactionKind | undefined;

	if (reactions.length > 0) {
		kind = reactions[0];

		icon = {
			kind: "svg",
			name: ensureNotNil(
				reactionIconMap[kind]
			)
		};
	} else {
		icon = "thumbs-up";
	}

	return {
		total,
		icon,
		kind
	};
}
